import { gql } from "@apollo/client";

export const GET_INSUMOS_VISITA_BY_EVALUACION = gql`
    query allInsumosVisitaByIdEvaluacion($where: t_InsumoFilterInput, $idEvaluacion: Int!) {
        allInsumosVisitaByIdEvaluacion(
            where: $where,
            idEvaluacion: $idEvaluacion
        ) {
            descripcion
            idInsumoN
            idUnidad
            idUnidadNavigation{
                alias
            }
            proteinas
            calorias
        }
    }
`;

export const adaptInsumo = (insumo) => {
  return {
    id: insumo?.idInsumoN,
    label: insumo?.descripcion,
    unidad: insumo?.idUnidadNavigation?.alias,
    idUnidad: insumo?.idUnidad,
    proteinas: insumo?.proteinas,
    calorias: insumo?.calorias
  };
};

export const adaptInsumoByEvaluacionArray = (insumos = []) => {
  if (!Array.isArray(insumos)) return [];

  return insumos.map(adaptInsumo);
};
